import { array, boolean, number, object, string } from 'yup'

export const DGELicenseFormValidationSchema = object().shape({
  licenseSportPropertyId: number().required('License Property is required'),
  allowLowLatencyPlayer: boolean(),
  archiveToDve: boolean(),
  archiveToS3: boolean(),
  allowLiveDvr: boolean(),
  allowApiVodAccess: boolean(),
  allowSrtSyndication: boolean(),
  autoBooking: boolean(),
  allowInteractiveStreaming: boolean(),
  bitRate: number(),
  geoBlockingType: string().oneOf(['none', 'whitelist', 'blacklist']),
  geoBlockingTerritories: array().of(string()),
  licensingPeriods: array()
    .min(1, 'Licensing Periods are required')
    .of(
      object().shape({
        year: string().required('Year is required'),
        startDate: string().required('Start date is required'),
        endDate: string().required('End date is required'),
        maxEvents: number().nullable(),
        purchasedEvents: number().nullable()
      })
    )
    .required('Licensing Periods are required')
})
